module.exports = __webpack_public_path__ + "img/25.9bf42996.png";